module.exports = __webpack_public_path__ + "static/media/mobile-fallback.6ef504ed.jpg";